(() => {
  if (window.__kyniqoHomeBooted) return;
  window.__kyniqoHomeBooted = true;

  const instances = new Map();
  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));
  const smooth = value => value * value * (3 - 2 * value);
  const mix = (a, b, value) => a + (b - a) * value;
  const stops = [
    { p:0, theta:108, phi:86, radius:210, y:0, color:[255,223,0] },
    { p:.18, theta:70, phi:76, radius:410, y:-20, color:[255,255,255] },
    { p:.34, theta:-45, phi:73, radius:470, y:-22, color:[255,255,255] },
    { p:.55, theta:-175, phi:79, radius:220, y:-1, color:[255,255,255] },
    { p:.75, theta:-260, phi:74, radius:320, y:15, color:[255,255,255] },
    { p:1, theta:-332, phi:68, radius:210, y:0, color:[255,255,255] }
  ];

  function kyniqoScroller(node) {
    let el = node?.parentElement;
    while (el && el !== document.body && el !== document.documentElement) {
      const overflow = getComputedStyle(el).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll' || overflow === 'overlay') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return window;
  }
  function kyniqoMetrics(scroller) {
    if (scroller === window) return { viewport: window.innerHeight, origin: 0 };
    return { viewport: scroller.clientHeight, origin: scroller.getBoundingClientRect().top };
  }
  function init(root) {
    if (!root || instances.has(root)) return;
    const events = new AbortController();
    const { signal } = events;
    const hero = root.querySelector('.kyniqo-hero');
    const menuButton = root.querySelector('.kyniqo-menu-toggle');
    const mobileNav = root.querySelector('.kyniqo-mobile-nav');
    const closeMenu = () => { if (!menuButton || !mobileNav) return; menuButton.setAttribute('aria-expanded', 'false'); mobileNav.hidden = true; };
    if (menuButton && mobileNav) {
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') !== 'true';
        menuButton.setAttribute('aria-expanded', String(open));
        mobileNav.hidden = !open;
      }, { signal });
      mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu, { signal }));
      document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); }, { signal });
    }
    const track = root.querySelector('.kyniqo-product-track');
    const stage = root.querySelector('[data-product-stage]');
    const model = root.querySelector('[data-product-model]');
    const buyModel = root.querySelector('.kyniqo-buy-finale-product model-viewer');
    const modelPosition = root.querySelector('[data-model-position]');
    const progressBar = root.querySelector('[data-product-progress]');
    const copy = [
      [root.querySelector('[data-copy="intro"]'), -.1, .2, .08],
      [root.querySelector('[data-copy="little"]'), .14, .45, .08],
      [root.querySelector('[data-copy="big"]'), .41, .7, .08],
      [root.querySelector('[data-copy="together"]'), .68, 1.16, .09]
    ];
    let baseOrbit = { theta:108, phi:86, radius:210 };
    let dragTheta = 0;
    let dragPhi = 0;
    let drag = null;
    let returnFrame = 0;
    let renderFrame = 0;
    let observer;
    let scroller = window;

    function updateOrbit() {
      if (!model) return;
      const theta = baseOrbit.theta + dragTheta;
      const phi = clamp(baseOrbit.phi + dragPhi, 12, 165);
      model.cameraOrbit = `${theta.toFixed(2)}deg ${phi.toFixed(2)}deg ${baseOrbit.radius.toFixed(2)}%`;
    }
    function returnToScroll(previousTime = 0) {
      const frame = time => {
        const elapsed = previousTime ? Math.min(64, time - previousTime) : 16;
        previousTime = time;
        const decay = Math.exp(-elapsed / 190);
        dragTheta *= decay;
        dragPhi *= decay;
        if (Math.abs(dragTheta) < .05 && Math.abs(dragPhi) < .05) {
          dragTheta = 0;
          dragPhi = 0;
          returnFrame = 0;
        } else returnFrame = requestAnimationFrame(frame);
        updateOrbit();
      };
      returnFrame = requestAnimationFrame(frame);
    }
    function endDrag(event) {
      if (!drag || (event?.pointerId != null && event.pointerId !== drag.id)) return;
      drag = null;
      model.classList.remove('kyniqo-dragging');
      if (returnFrame) cancelAnimationFrame(returnFrame);
      returnToScroll();
    }
    if (model) {
      model.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (returnFrame) cancelAnimationFrame(returnFrame);
        drag = { id:event.pointerId, x:event.clientX, y:event.clientY, theta:dragTheta, phi:dragPhi };
        model.classList.add('kyniqo-dragging');
        if (event.pointerType === 'mouse') {
          event.preventDefault();
          model.setPointerCapture(event.pointerId);
        }
      }, { signal });
      model.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        dragTheta = drag.theta - (event.clientX - drag.x) * .55;
        dragPhi = drag.phi + (event.clientY - drag.y) * .32;
        updateOrbit();
      }, { signal });
      model.addEventListener('pointerup', endDrag, { signal });
      model.addEventListener('pointercancel', endDrag, { signal });
      window.addEventListener('pointerup', endDrag, { signal });
      window.addEventListener('blur', endDrag, { signal });
    }

    if (buyModel) {
      let buyDragging = false;
      buyModel.addEventListener('pointerdown', () => { buyDragging = true; }, { signal });
      const resetBuyOrbit = () => {
        if (!buyDragging) return;
        buyDragging = false;
        requestAnimationFrame(() => { buyModel.cameraOrbit = '108deg 68deg 90%'; });
      };
      buyModel.addEventListener('pointerup', resetBuyOrbit, { signal });
      buyModel.addEventListener('pointercancel', resetBuyOrbit, { signal });
      window.addEventListener('pointerup', resetBuyOrbit, { signal });
      window.addEventListener('blur', resetBuyOrbit, { signal });
    }

    function updateCopy(node, progress, start, end, fade) {
      if (!node) return;
      const opacity = Math.min(clamp((progress - start) / fade), clamp((end - progress) / fade));
      const movement = clamp((progress - start) / (end - start));
      node.style.setProperty('--kyniqo-opacity', opacity.toFixed(3));
      node.style.setProperty('--kyniqo-shift', `${Math.round((1 - movement) * 36 - movement * 22)}px`);
      node.style.setProperty('--kyniqo-scale', (0.84 + movement * .23).toFixed(3));
    }
    function render() {
      renderFrame = 0;
      const { viewport, origin } = kyniqoMetrics(scroller);
      const heroProgress = clamp((origin - hero.getBoundingClientRect().top) / Math.max(1, hero.offsetHeight));
      hero.style.setProperty('--kyniqo-hero-scale', (1.03 + heroProgress * .08).toFixed(3));
      hero.style.setProperty('--kyniqo-hero-shift', `${Math.round(heroProgress * 27)}px`);
      const range = Math.max(1, track.offsetHeight - viewport);
      const progress = clamp((origin - track.getBoundingClientRect().top) / range);
      let i = 0;
      while (i < stops.length - 2 && progress > stops[i + 1].p) i++;
      const a = stops[i], b = stops[i + 1];
      const t = smooth(clamp((progress - a.p) / (b.p - a.p)));
      baseOrbit = { theta:mix(a.theta,b.theta,t), phi:mix(a.phi,b.phi,t), radius:mix(a.radius,b.radius,t) };
      updateOrbit();
      modelPosition.style.transform = `translate3d(0, ${mix(a.y,b.y,t).toFixed(2)}vh, 0)`;
      const color = a.color.map((value, index) => Math.round(mix(value,b.color[index],t)));
      stage.style.backgroundColor = `rgb(${color.join(',')})`;
      progressBar.style.transform = `scaleY(${progress.toFixed(3)})`;
      copy.forEach(([node,start,end,fade]) => updateCopy(node,progress,start,end,fade));
    }
    function schedule() {
      if (!renderFrame) renderFrame = requestAnimationFrame(render);
    }
    scroller = kyniqoScroller(root);
    window.addEventListener('scroll', schedule, { passive:true, capture:true, signal });
    if (scroller !== window) scroller.addEventListener('scroll', schedule, { passive:true, signal });
    window.addEventListener('resize', schedule, { signal });
    render();

    const reveals = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          entry.target.classList.add('kyniqo-visible');
          observer.unobserve(entry.target);
        }
      }, { threshold:.14 });
      reveals.forEach(item => observer.observe(item));
    } else reveals.forEach(item => item.classList.add('kyniqo-visible'));

    instances.set(root, () => {
      events.abort();
      if (renderFrame) cancelAnimationFrame(renderFrame);
      if (returnFrame) cancelAnimationFrame(returnFrame);
      observer?.disconnect();
      instances.delete(root);
    });
  }

  document.querySelectorAll('[data-kyniqo-home]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('[data-kyniqo-home]')) init(event.target);
    event.target.querySelectorAll?.('[data-kyniqo-home]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target.contains(root)) destroy();
  });
})();
